import { useTranslation } from 'react-i18next';

type UrgencyLevel = 'critical' | 'high' | 'medium' | 'low';

interface PriorityBadgeProps {
  level: UrgencyLevel;
}

const levelColors: Record<UrgencyLevel, string> = {
  critical: 'bg-red-100 text-red-700 border-red-300',
  high: 'bg-orange-100 text-orange-700 border-orange-300',
  medium: 'bg-yellow-100 text-yellow-700 border-yellow-300',
  low: 'bg-gray-100 text-gray-600 border-gray-300',
};

const dotColors: Record<UrgencyLevel, string> = {
  critical: 'bg-red-600',
  high: 'bg-orange-500',
  medium: 'bg-yellow-500',
  low: 'bg-gray-400',
};

export default function PriorityBadge({ level }: PriorityBadgeProps) {
  const { t } = useTranslation();

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${levelColors[level]}`}
    >
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${dotColors[level]}`} />
      {t(`urgency.${level}`)}
    </span>
  );
}
